import { MainView } from "../../views/profile/index";

export default function Component(props) {
    return (
        <>
            <MainView />
        </>
    );
}